import React from 'react';

import { ANALYTICS_HEAP_IDS, formatHeapId } from '@/common/constants';
import { CTA, CTAProps } from '@/components/CTA';
import { MarketingSectionBlockDesktop } from '../components/MarketingSectionBlock/MarketingSectionBlockDesktop';
import { MarketingSectionBlockMobile } from '../components/MarketingSectionBlock/MarketingSectionBlockMobile';
import { SectionProps } from '../components/MarketingSectionBlock/types';
import { SocialMediaIcon, SocialMediaIconProps } from '../components/SocialMediaIcon';
import styles from './MarketingSection.module.scss';

export interface MarketingSectionProps {
  sections: SectionProps[];
  ctas?: CTAProps[];
  socialMediaIconLinks?: SocialMediaIconProps[];
}

export const MarketingSection: React.FC<MarketingSectionProps> = ({
  sections,
  ctas,
  socialMediaIconLinks,
}) => {
  const validCtas = ctas?.filter((cta) => cta.link && cta.label);

  return (
    <div className={styles.container}>
      <div className={styles['marketing-sections-desktop']}>
        {sections.map((section, index) => (
          <MarketingSectionBlockDesktop
            key={`Desktop-${section.sectionName}-${index}`}
            sectionName={section.sectionName}
            marketingLinks={section.marketingLinks}
          />
        ))}
      </div>
      <div className={styles['marketing-sections-mobile']}>
        {sections.map((section, index) => (
          <MarketingSectionBlockMobile
            key={`Mobile-${section.sectionName}-${index}`}
            sectionName={section.sectionName}
            marketingLinks={section.marketingLinks}
            defaultOpen={index === 0}
          />
        ))}
      </div>
      <div className={styles['ctas-socials']}>
        {validCtas && validCtas.length > 0 && (
          <div className={styles.ctas}>
            {validCtas.map((cta, index) => (
              <CTA
                key={`Footer-CTA-${index}`}
                label={cta.label}
                link={cta.link}
                type={cta.type}
                dataHeapId={formatHeapId([ANALYTICS_HEAP_IDS.FOOTER_MARKETING, cta.label])}
              />
            ))}
          </div>
        )}
        {socialMediaIconLinks && (
          <div className={styles.socials}>
            {socialMediaIconLinks.reverse().map((socialMediaIconLink, index) => (
              <SocialMediaIcon
                key={`Social-Icon-${index}`}
                icon={socialMediaIconLink.icon}
                link={socialMediaIconLink.link}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
